import React from 'react';

export default function CardContent({ children }) {
  return (
    <div className="p-4">
      {children}
    </div>
  );
}
